module.exports = __webpack_public_path__ + "static/6d-04a3eb9b7b4ba1135b1c6cab619c12ca.jpg";